<app-new-note [moduleId]="moduleId" [entityId]="entityId" [breadCrumbInputs]="breadCrumbInputs"></app-new-note>